import React from 'react';
import { bool } from 'prop-types';

const Disclaimer = ({ hideMargin }) => {
  const disclaimer =
    '* Checking your loan rate generates a soft credit inquiry on your credit report,\n which is visible only to you. A hard credit inquiry, which is visible to you and others,\n and which may affect your credit score, only appears on your credit report if and when a loan is issued to you.';

  return <div className={hideMargin ? 'disclaimer disclaimer--hideMargin' : 'disclaimer'}>{disclaimer}</div>;
};

Disclaimer.propTypes = {
  hideMargin: bool,
};

Disclaimer.defaultProps = {
  hideMargin: false,
};

export default Disclaimer;

require('/var/lib/jenkins/workspace/borrower-apply-ui_Release_0/src/pages/pi1-1QAAT/components/Disclaimer/Disclaimer.scss');